import { createApi } from '@reduxjs/toolkit/query/react';
import { getConfig } from '@/config';
import { clientKeyBaseQuery } from './clientKeyBaseQuery';
// ---------------------------------------------------------------------------
// API slice
// ---------------------------------------------------------------------------
/**
 * Dedicated RTK Query API slice for recommendation results.
 *
 * This slice has its own `fetchBaseQuery` because the Recs API uses
 * `client-key` authentication — not the Bearer-token auth that `ccApi`
 * injects via `prepareHeaders`.  A separate slice avoids fighting
 * `ccApi`'s auth pipeline and gives clean `fetchBaseQuery` benefits
 * (automatic JSON handling, error normalisation, etc.).
 *
 * The `clientKey` is passed per-request because it varies by tenant
 * configuration.
 *
 * @see https://redux-toolkit.js.org/rtk-query/api/created-api/code-splitting
 */
export const recommendationsResultsApi = createApi({
    reducerPath: 'recommendationsResultsApi',
    baseQuery: clientKeyBaseQuery,
    endpoints: (builder) => ({
        getRecommendationsResults: builder.mutation({
            query: ({ clientKey, body }) => ({
                url: getConfig().recsApiUrl,
                method: 'POST',
                body,
                headers: {
                    Authorization: `client-key ${clientKey}`,
                },
            }),
        }),
    }),
});
export const { useGetRecommendationsResultsMutation, } = recommendationsResultsApi;
